import { render } from "./HeroiconsSolidChevronDoubleUp.vue?vue&type=template&id=bd072932"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronDoubleUp.vue"]])

export default __exports__